import { render, staticRenderFns } from "./FormHeadingWrapper.vue?vue&type=template&id=5d3446c4&scoped=true&lang=pug&"
import script from "./FormHeadingWrapper.vue?vue&type=script&lang=js&"
export * from "./FormHeadingWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FormHeadingWrapper.vue?vue&type=style&index=0&id=5d3446c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3446c4",
  null
  
)

export default component.exports